namespace HA.Core.HTML.TBox {
    export class Section extends Pane {

        protected createItem(data: Map<any, any>) {
            const _d = data.get("d");
            switch (data.get("t")) {
                case "l":
                    return new ItemList({d: _d});
                case "sl":
                    return new SimpleItemList({d: _d});
                case "p":
                    const t = new Div(_d);
                    t.addClass("p");
                    return t;
                case "t":
                    const t2 = new Div(_d);
                    t2.addClass("t2");
                    return t2;
                default :
                    return null;
            }

        }

        protected createSelf() {
            super.createSelf();
            this.addClass("sect");
            const me = this;
            const tdata = this.get("d");

            if (tdata) {
                tdata.forEach((item: any) => {
                    me.appendChild(me.createItem(toMap(item)));
                });
            }

        }
    }
}
